import { AscDesc } from 'stream-chat';

export const ASC: AscDesc = 1;
export const DESC: AscDesc = -1;
